import { AssignmentTypeOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { AssignmentTypeState } from "@redotech/redo-return-ui/flows/rules/conditions/assignment-type";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";

export const AssignmentTypeDetails = memo(function AssignmentTypeDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<AssignmentTypeState>) {
  const assignmentOptions = [
    {
      id: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
      type: "text" as const,
      text: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
      value: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
    },
    {
      id: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
      type: "text" as const,
      text: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
      value: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
    },
    {
      id: AssignmentTypeOption.NO_ASSIGNEE,
      type: "text" as const,
      text: AssignmentTypeOption.NO_ASSIGNEE,
      value: AssignmentTypeOption.NO_ASSIGNEE,
    },
  ];

  const selectedAssignment = assignmentOptions.find(
    (option) => option.id === state.assignmentType,
  );

  return (
    <RedoSingleSelectDropdownInput
      label="Assignment"
      options={assignmentOptions}
      optionSelected={({ item }) => {
        setState({
          ...state,
          assignmentType: item.id as typeof state.assignmentType,
        });
      }}
      selectedItem={selectedAssignment}
    />
  );
});
